module.exports = __webpack_public_path__ + "static/img/b-thpost.ecf309b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/b-thpost.png
// module id = YGiq
// module chunks = 31